import { Box, Button, CircularProgress, FormControl, IconButton, Menu, MenuItem, OutlinedInput, Pagination, Select, Typography } from "@mui/material";
import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPermissionData, getUserData } from "../../Actions/common";
import { getPayCentralTenantAction } from "../../Actions/PaycentralAction";
import { listAllCommonTenants } from "../../Actions/PaycentralAction";
import { PaylistTransactionDataAction, exportTransactionPaycentralHistoryAction } from "../../Actions/PaycentralAction"
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import { default as CoustomTooltip, default as CustomTooltip } from "../../Assets/customTheme/customtooltip";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { ITEMS_PER_PAGE_OPTIONS } from "../../config";
import { formatCurrency } from "../../utils/CommonFunctions";
import { formatDateTime } from "../Common/DateFormat";
import ExportDialog from "../Common/ExportModal";
import CustomSnackbar from "../Common/snackBar";
import PaycentralTransactionCards from "./TransactionCards";
import renderStatusBadge from "../../utils/badges";
import { MyDescriptionOutlinedIcon, MyExportIcon, MySearchIcon } from "../../Assets/svg/MyIcons";
import DateRangePicker from "../Common/DateRangePicker";
import PaycentralTransactionInvoiceModal from "./TransactionInvoiceModal";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const getDefaultDateRange = () => {
  const end = new Date();
  const start = new Date();
  start.setMonth(start.getMonth() - 1);
  return { from: start, to: end };
};

const CustomToolbar = ({
  SelectDropdown_SX,
  searchValue,
  handleSearchApi,
  handleFilterData,
  handleResetFilters,
  isDashboardView,
  handleChangeDropdown,
  statusFilter,
  amountFilter,
  tenantFilter,
  merchantData,
  handleExportOption,
  handleExportClick,
  handleMenuClose,
  isMenuOpen,
  anchorEl,
  filterButtonDisabled,
  resetButtonDisabled,
  hasPermission,
  exportLoader,
  transactionData,
  selectedRange,
  onRangeChange,
  currencyFilter
}) => {
  const navigate = useNavigate();
  if (isDashboardView) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 16px 25px 16px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography
          variant="h5"
          component="div"
          sx={{
            fontWeight: "bold",
          }}
        >
          Recent Transactions
        </Typography>

        <span
          className="btn btn-primary btn-sm d-flex align-items-center"
          onClick={() => navigate("/transactions")}
        >
          View All
        </span>
      </Box>
    );
  }

  return (
    <div
      className="custom-header"
      style={{
        overflowX: "auto",
        whiteSpace: "nowrap",
      }}
    >
      <div className="card border-rounded-0 fiter-card">
        <div className="card-body p-5 pb-0">
          <div className="row align-items-center flex-nowrap mb-6">
            {/* Search */}
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6 mb-5">
              <div className="position-relative">
                <MySearchIcon className="fs-2 text-gray-500 position-absolute top-50 translate-middle-y ms-4" />
                <input
                  type="text"
                  className="search-input form-control ps-12"
                  placeholder="Search Organization"
                  name="search"
                  value={searchValue}
                  onChange={handleSearchApi}
                />
              </div>
            </div>

            {/* Date */}
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-3 col-sm-6 mb-5">
              <DateRangePicker
                selectedRange={selectedRange}
                onRangeChange={onRangeChange}
                maxDate={new Date()}
                placeholder="Select date range"
              />
            </div>

            {/* Status */}
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-3 col-sm-6 mb-5">
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  value={statusFilter}
                  onChange={(e) => handleChangeDropdown(e, "statusFilter")}
                  input={<OutlinedInput />}
                  MenuProps={MenuProps}
                  sx={SelectDropdown_SX}
                >
                  <MenuItem value="all">Select Status</MenuItem>
                  <MenuItem value="PENDING">Pending</MenuItem>
                  <MenuItem value="SUCCESS">Completed</MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* Currency */}
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-3 col-sm-6 mb-5">
              <FormControl fullWidth>
                <Select
                  key={currencyFilter}
                  displayEmpty
                  value={currencyFilter}
                  onChange={(e) => handleChangeDropdown(e, "currencyFilter")}
                  input={<OutlinedInput />}
                  MenuProps={MenuProps}
                  sx={SelectDropdown_SX}
                  renderValue={(selected) => {
                    if (!selected || selected === "all") {
                      return "Select Currency";
                    }
                    return selected; // USD / KYD
                  }}
                >
                  <MenuItem value="all">Select Currency</MenuItem>
                  <MenuItem value="USD">USD</MenuItem>
                  <MenuItem value="KYD">KYD</MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* Merchant */}
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-3 col-sm-6 mb-5">
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  value={tenantFilter}
                  onChange={(e) => handleChangeDropdown(e, "tenantFilter")}
                  input={<OutlinedInput />}
                  MenuProps={MenuProps}
                  sx={SelectDropdown_SX}
                  disabled={merchantData?.length === 0}
                >
                  <MenuItem value="all">Select Tenant</MenuItem>
                  {merchantData?.map((merchant) => (
                    <MenuItem
                      key={merchant.id}
                      value={merchant.id}
                    >
                      {merchant.organizationName || `${merchant.firstName || ""} ${merchant.lastName || ""}`.trim() || "N/A"}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Action Buttons */}
            <div className="col-auto ms-auto d-flex align-items-center gap-2 mb-5">
              <CustomTooltip
                title="Filter"
                placement="top"
                arrow
              >
                <span>
                  <button
                    className="btn text-primary btn-light btn-icon"
                    onClick={handleFilterData}
                    disabled={filterButtonDisabled}
                  >
                    <TableFilte />
                  </button>
                </span>
              </CustomTooltip>

              <CustomTooltip
                title="Reset"
                placement="top"
                arrow
              >
                <span>
                  <button
                    className="btn btn-light text-primary btn-icon"
                    onClick={handleResetFilters}
                    disabled={resetButtonDisabled}
                  >
                    <TableReset />
                  </button>
                </span>
              </CustomTooltip>

              <CoustomTooltip
                title="Column Filter"
                placement="top"
                arrow
              >
                <span style={{ display: "inline-block" }}>
                  <GridToolbarColumnsButton
                    slotProps={{
                      tooltip: { title: "" },
                      button: {
                        className: "btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
                        style: {
                          width: "47px",
                          height: "44px",
                          minWidth: "unset",
                          borderRadius: "8px",
                        },
                        startIcon: <TableColumns />,
                      },
                    }}
                  />
                </span>
              </CoustomTooltip>

              {hasPermission?.canExport && (
                <>
                  <CoustomTooltip>
                    <span>
                      <Button
                        className="btn btn-primary"
                        aria-controls={isMenuOpen ? "export-menu" : undefined}
                        aria-haspopup="true"
                        disabled={exportLoader || transactionData.length === 0}
                        onClick={handleExportClick}
                      >
                        <MyExportIcon className="text-white h-2 w-2 me-1" /> Export
                        {exportLoader && (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </Button>
                    </span>
                  </CoustomTooltip>
                  <Menu
                    id="export-menu"
                    anchorEl={anchorEl}
                    open={isMenuOpen}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={() => handleExportOption("Excel")}>Export as Excel</MenuItem>
                    <MenuItem onClick={() => handleExportOption("PDF")}>Export as PDF</MenuItem>
                  </Menu>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};




const PaycentralTransactionSection = ({ isDashboardView = false }) => {
  const [selectedColumns, setSelectedColumns] = useState([]);

  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(isDashboardView ? 5 : ITEMS_PER_PAGE_OPTIONS[0]);

  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const [loading, setLoading] = useState(true);
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
  const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
  const [transactionData, setTransactionData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [enableFilterButton, setEnableFilterButton] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [shouldFetchData, setShouldFetchData] = useState(1);

  const [statusFilter, setStatusFilter] = useState("all");
  const [amountFilter, setAmountFilter] = useState("all");
  const [tenantFilter, setTenantFilter] = useState("all");
  const [currencyFilter, setCurrencyFilter] = useState("all");
  const [websiteDisabled, setWebsiteDisabled] = useState(true);
  const [merchantData, setMerchantData] = useState([]);

  // Date range states
  const defaultRange = getDefaultDateRange();
  const [selectedRange, setSelectedRange] = useState(defaultRange);
  const [startDate, setStartDate] = useState(defaultRange.from.toISOString());
  const [endDate, setEndDate] = useState(defaultRange.to.toISOString());
  const [exportType, setExportType] = useState("");
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [exportScope, setExportScope] = useState("thisPage");
  const [exportLoader, setExportLoader] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({});
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const permissionData = localStorage.getItem(`${userData?.id}_permissionData`)
    ? getPermissionData(`${userData?.id}_permissionData`)
    : [];
  const hasPermission = permissionData[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "transaction");
  const [shouldRefreshCards, setShouldRefreshCards] = useState(0);
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSnackBar = (severity = null, message) => {
    if (severity)
      setSnackbar({
        open: true,
        message: message || "Something went wrong...!",
        severity,
      });
  };

  const getMerchantListData = async () => {
    try {
      const res = await listAllCommonTenants();

      const rawData = res?.data?.data || [];

      // ✅ Apply your condition here
      const filteredData = rawData.filter((tenant) => {
        const hasQId = tenant.qId !== null && tenant.qId !== undefined;
        const hasPId = tenant.pId !== null && tenant.pId !== undefined;

        // ❌ Hide only when qId exists but pId does NOT
        if (hasQId && !hasPId) {
          return false;
        }

        return true;
      });

      setMerchantData(filteredData);

    } catch (error) {
      setSnackbar({
        open: true,
        message:
          error?.response?.data?.message ||
          "Something went wrong. Please try again later.",
        severity: "error",
      });
    }
  };
  // const websiteId = tenantFilter !== "all" ? tenantFilter : null;
  const getTransactionData = useCallback(async () => {
    setLoading(true);

    await PaylistTransactionDataAction(
      selectedRowsPerPage,
      currentPage,
      statusFilter,
      tenantFilter,
      startDate,
      endDate,
      searchValue
    )
      .then((res) => {
        const response = res.data;

        setTransactionData(response?.data?.data || []);
        setTotalRecords(response?.data?.totalCount || 0);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error?.response?.data?.message || "Something went wrong",
          severity: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    selectedRowsPerPage,
    currentPage,
    statusFilter,
    tenantFilter,
    startDate,
    endDate
  ]);

  useEffect(() => {
    getMerchantListData();
  }, []);

  useEffect(() => {
    if (shouldFetchData) {
      getTransactionData();
      setShouldFetchData(0);
    }
  }, [shouldFetchData]);

  const handleSearchApi = (e) => {
    const inputValue = e.target.value;
    if (inputValue.length === 0) {
      setFilterButtonDisabled(true);
    } else {
      setFilterButtonDisabled(false);
    }
    setSearchValue(inputValue);
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  const handleRangeChange = (range) => {
    setFilterButtonDisabled(false);
    setResetButtonDisabled(false);

    if (!range) {
      setSelectedRange({ from: undefined, to: undefined });
      setStartDate(null);
      setEndDate(null);
      return;
    }

    setSelectedRange(range);

    if (range.from) {
      const year = range.from.getFullYear();
      const month = range.from.getMonth();
      const day = range.from.getDate();
      const startDateObj = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
      setStartDate(startDateObj.toISOString());
    }

    if (range.to) {
      const year = range.to.getFullYear();
      const month = range.to.getMonth();
      const day = range.to.getDate();
      const endDateObj = new Date(Date.UTC(year, month, day, 23, 59, 59, 999));
      setEndDate(endDateObj.toISOString());
    }
  };

  const handleResetFilters = () => {
    const defaultRange = getDefaultDateRange();
    setLoading(true);
    setSearchValue("");
    setCurrentPage(1);
    setShouldFetchData(1);
    setEnableFilterButton(false);
    setLoading(true);
    setTransactionData([]);
    setSelectedRange(defaultRange);
    setStartDate(defaultRange.from.toISOString());
    setEndDate(defaultRange.to.toISOString());
    setStatusFilter("all");
    setAmountFilter("all");
    setTenantFilter("all");
    setCurrencyFilter("all");
    setResetButtonDisabled(true);
    setFilterButtonDisabled(true);
    setWebsiteDisabled(true);
    setShouldRefreshCards(prev => prev + 1);
  };
  useEffect(() => {
  }, [currencyFilter]);


  const handleChangeDropdown = (e, filterName) => {
    const selectedValue = e.target.value;

    if (filterName === "tenantFilter") {
      setTenantFilter(selectedValue);
    } else if (filterName === "statusFilter") {
      setStatusFilter(selectedValue);
    } else if (filterName === "amountFilter") {
      setAmountFilter(selectedValue);
    } else if (filterName === "currencyFilter") {
      setCurrencyFilter(selectedValue);
    }

    setFilterButtonDisabled(false);
    setResetButtonDisabled(false);

  };

  const handleFilterData = () => {
    setCurrentPage(1);
    setEnableFilterButton(true);
    setLoading(true);
    setShouldFetchData(1);
    setTransactionData([]);
    setFilterButtonDisabled(true);
    setResetButtonDisabled(false);
    setShouldRefreshCards(prev => prev + 1);

  };

  const SelectDropdown_SX = {
    "& .MuiSelect-select": {
      padding: "11px",
      textAlign: "start",
    },
    fieldset: {
      borderColor: "#e1e3ea !important",
      borderRadius: "30px",
    },
  };

  const columns = [
    {
      field: "organizationName",
      headerName: "Organization Name",
      minWidth: 200,
      flex: 1.2,
      renderCell: (params) => params.row?.organizationName || "-",
    },
    {
      field: "oneTimeSetupFee",
      headerName: "One Time Setup Fee",
      minWidth: 160,
      flex: 1,
      renderCell: (params) =>
        params.row?.oneTimeSetupFee
          ? `${params.row.oneTimeSetupFee}`
          : "0",
    },
    {
      field: "ongoingMaintenanceFee",
      headerName: "Ongoing Maintenance Fee",
      minWidth: 180,
      flex: 1,
      renderCell: (params) =>
        params.row?.ongoingMaintenanceFee
          ? `${params.row.ongoingMaintenanceFee}`
          : "0",
    },
    {
      field: "newMerchantSetupFee",
      headerName: "New Merchant Setup Fee",
      minWidth: 180,
      flex: 1,
      renderCell: (params) =>
        params.row?.newMerchantSetupFee
          ? `${params.row.newMerchantSetupFee}`
          : "0",
    },
    {
      field: "ongoingMaintenancePerMerchantFee",
      headerName: "Maintenance / Merchant Fee",
      minWidth: 200,
      flex: 1,
      renderCell: (params) =>
        params.row?.ongoingMaintenancePerMerchantFee
          ? `${params.row.ongoingMaintenancePerMerchantFee}`
          : "0",
    },
    {
      field: "totalFee",
      headerName: "Total Fee",
      minWidth: 200,
      flex: 1,
      renderCell: (params) =>
        params.row?.totalFee
          ? `${params.row.totalFee}`
          : "0",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 0.8,
      renderCell: (params) => {
        const status = (params.row?.status || "").toLowerCase();

        const map = {
          success: { title: "Completed", status: "success" },
          pending: { title: "Pending", status: "pending" },
        };

        return renderStatusBadge(
          map[status] || {
            title: "Unknown",
            status: "default",
          }
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      minWidth: 180,
      flex: 1,
      renderCell: (params) =>
        params.row?.createdAt
          ? formatDateTime(params.row.createdAt, true)
          : "-",
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 120,
      flex: 0.6,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <CustomTooltip title="View Invoice" placement="top" arrow>
          <span>
            <button
              className="btn btn-light text-primary btn-icon"
              onClick={() => handleOpenInvoice(params.row)}
            >
              <MyDescriptionOutlinedIcon />
            </button>
          </span>
        </CustomTooltip>
      ),
    }
  ];

  // const handlePdfDownload = async (pdf) => {
  //   const pdfUrl = `${MEDIA_URL}/${pdf}`;
  //   try {
  //     const response = await fetch(pdfUrl);
  //     const blob = await response.blob();
  //     const blobUrl = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = blobUrl;
  //     link.setAttribute("download", pdf);
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(blobUrl);
  //   } catch (error) {
  //     console.error("Error downloading PDF:", error);
  //   }
  // };

  const handleRowsPerPageChange = (event) => {
    const newValue = parseInt(event.target.value);
    setSelectedRowsPerPage(newValue);
    setCurrentPage(1);
    setLoading(true);
    setShouldFetchData(1);
    setTransactionData([]);
  };

  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleExportOption = (type) => {
    setExportType(type);
    // Preselect visible columns except 'actions'
    let defaultColumns = columns.filter((col) => col.field !== "actions" && visibleColumns[col.field] !== false).map((col) => col.field);
    setSelectedColumns(defaultColumns);
    setExportDialogOpen(true);
    handleMenuClose();
  };

  const handleExportConfirm = async (exportColumnsArg, exportScopeArg) => {
    setExportLoader(true);

    let columnsData = exportColumnsArg || selectedColumns;
    const scope = exportScopeArg || exportScope;

    const data = {
      exportType,
      exportScope: scope,
      page: scope === "thisPage" ? currentPage : null,
      pageSize: scope === "thisPage" ? selectedRowsPerPage : null,
      status: statusFilter,
      amount: amountFilter,
      searchValue,
      startDate,
      endDate,
      tenantDb: tenantFilter !== "all" ? tenantFilter : null,//
      exportColumns: columnsData,
    };

    try {
      const res = await exportTransactionPaycentralHistoryAction(data);

      // ✅ SAFE CONTENT TYPE CHECK
      const contentType = res?.type || "";

      if (contentType.includes("application/json")) {
        setSnackbar({
          open: true,
          message: "There is no data exist for export.",
          severity: "info",
        });
      } else {
        // ✅ FILE DOWNLOAD
        const blob = new Blob([res]);
        const timestamp = new Date().getTime();

        let fileName;

        switch (exportType) {
          case "Excel":
            fileName = `transaction_${timestamp}.xlsx`;
            break;
          case "PDF":
            fileName = `transaction_report_${timestamp}.pdf`;
            break;
          default:
            fileName = `export_${timestamp}.txt`;
        }

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);

        setSnackbar({
          open: true,
          message: "Data exported successfully",
          severity: "success",
        });
      }
    } catch (error) {
      console.error("EXPORT ERROR:", error);

      let message = "Something went wrong";

      // ✅ SAFE ERROR HANDLING (NO CRASH)
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      }

      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      handleMenuClose();
      setExportLoader(false);
      setExportScope("thisPage");
      setExportDialogOpen(false);
    }
  };

  const handleOpenInvoice = (transaction) => {
    setSelectedTransaction(transaction);
    setInvoiceModalOpen(true);
  };

  const handleCloseInvoice = () => {
    setInvoiceModalOpen(false);
    setSelectedTransaction(null);
  };

  return (
    <div>
      {!isDashboardView && <BreadcrumbsComponent />}

      {/* Summary Cards */}
      {!isDashboardView && (
        <div style={{ background: "#f1f5f9", padding: "1px" }}>
          <PaycentralTransactionCards
            handleSnackBar={handleSnackBar}
            startDate={startDate}
            endDate={endDate}
            statusFilter={statusFilter}
            tenantDb={tenantFilter}
            searchValue={searchValue}
            amountFilter={amountFilter}
            shouldRefresh={shouldRefreshCards}
          />
        </div>
      )}
      {/* End Summary Cards */}

      <DataGrid
        getRowId={(row) => row.id}
        localeText={{ toolbarColumns: "" }}
        rows={transactionData}
        columns={columns}
        autoHeight
        hideFooterRowCount={true}
        hideFooterPagination={true}
        hideFooter={true}
        loading={loading}
        disableRowSelectionOnClick
        columnVisibilityModel={visibleColumns}
        onColumnVisibilityModelChange={(newModel) => {
          setVisibleColumns(newModel);
        }}
        slots={{
          toolbar: CustomToolbar,
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        slotProps={{
          toolbar: {
            SelectDropdown_SX,
            searchValue,
            handleSearchApi,
            handleFilterData,
            handleResetFilters,
            enableFilterButton,
            isDashboardView,
            handleChangeDropdown,
            statusFilter,
            amountFilter,
            tenantFilter,
            merchantData,
            handleExportOption,
            handleExportClick,
            handleMenuClose,
            isMenuOpen,
            anchorEl,
            filterButtonDisabled,
            resetButtonDisabled,
            hasPermission,
            exportLoader,
            transactionData,
            websiteDisabled,
            setWebsiteDisabled,
            selectedRange,
            onRangeChange: handleRangeChange,
          },
        }}
        components={{
          loadingOverlay: () => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
              }}
            >
              <CircularProgress
                color="primary"
                size={24}
                style={{ marginRight: 10 }}
              />
              Loading...
            </div>
          ),
          noRowsOverlay: () =>
            !loading && transactionData.length === 0 ? (
              <div
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                No Records Found
              </div>
            ) : null,
        }}
        sx={DataGrid_SX}
      />

      {!isDashboardView && transactionData.length > 0 && (
        <div className="card-footer d-flex align-items-center justify-content-between mt-7">
          <div className="d-flex align-items-center">
            <label className="fw-semibold me-3">Row per page:</label>
            <FormControl
              variant="standard"
              style={{
                minWidth: 50,
              }}
            >
              <Select
                labelId="rows-per-page-label"
                id="rows-per-page"
                value={selectedRowsPerPage}
                onChange={handleRowsPerPageChange}
                label="Rows per page"
              >
                {ITEMS_PER_PAGE_OPTIONS.map((option) => (
                  <MenuItem
                    key={option}
                    value={option}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <Pagination
            count={Math.ceil(totalRecords / selectedRowsPerPage)}
            siblingCount={0}
            page={currentPage}
            onChange={(event, value) => {
              if (value !== currentPage) {
                setCurrentPage(value);
                setShouldFetchData(1);
                setTransactionData([]);
                setLoading(true);
              }
            }}
            variant="outlined"
            shape="rounded"
            className="custom-pagination mt-0 ms-5"
          />
        </div>
      )}

      {exportDialogOpen && (
        <ExportDialog
          open={exportDialogOpen}
          onClose={() => setExportDialogOpen(false)}
          exportScope={exportScope}
          setExportScope={setExportScope}
          onExport={handleExportConfirm}
          columns={columns}
          selectedColumns={selectedColumns}
          setSelectedColumns={setSelectedColumns}
        />
      )}

      {invoiceModalOpen && (
        <PaycentralTransactionInvoiceModal
          open={invoiceModalOpen}
          handleClose={handleCloseInvoice}
          transactionData={selectedTransaction}
        />
      )}

      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </div>
  );
};

export default PaycentralTransactionSection;
